// All yup Items

import { object, string } from "yup";

const YUP = { object, string };

export default YUP;
